// Forked into ../redesign/RecentSearches/RecentSearchItem.tsx — keep in sync until phase_0 cleanup.
import React from 'react';
import styled from 'styled-components';
import { Button, token } from '@bynder/design-system';
import { useNavigableItem } from '../KeyboardNavigation';

interface Props {
	term: string;
	onSelect: () => void;
}

export function RecentSearchItem({ term, onSelect }: Props) {
	const { isActive, itemRef, select } = useNavigableItem<HTMLLIElement>(onSelect);

	return (
		<StyledLI ref={itemRef} $isActive={isActive}>
			<Button onClick={select} variant="clean" isSmall isFullWidth>
				<StyledContentDiv>
					<div>{term}</div>
				</StyledContentDiv>
			</Button>
		</StyledLI>
	);
}

const StyledLI = styled.li<{ $isActive: boolean }>`
	display: flex;
	width: 100%;
	border-radius: ${token.radiusLarge};
	padding: 0 ${token.spacing1};
	${({ $isActive }) => $isActive && `background-color: ${token.gray25};`}
	&:last-child {
		margin-bottom: 10px;
	}

	button {
		&:focus,
		&:focus-visible,
		&:active {
			outline: none !important;
			border: none;
			box-shadow: none; /* in case the DS uses a focus ring via box-shadow */
		}
	}
`;

const StyledContentDiv = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 6px;
`;
